import React from 'react';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-content">
          <h2>It all begins with an idea</h2>
          <div className="underline-small"></div>
          <p className="about-text">
            Taking <strong>ideas</strong>, moving to <strong>concepts</strong>, design proofs, and finally an <strong>Award-Winning product</strong> without breaking the bank!
          </p>
          <div className="icon-drawing"></div>
        </div>
      </div>
    </section>
  );
};

export default About;




